import { memo } from 'react'

import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg'

export const LoginAccountReviewIllustration = () => {
  return (
    <Svg width={192} height={181} viewBox="0 0 192 181" fill="none">
      <G clipPath="url(#clip0_8964_174175)">
        <Path
          d="M71.2333 141.076C110.082 141.076 141.575 109.583 141.575 70.7342C141.575 31.8856 110.082 0.392578 71.2333 0.392578C32.3846 0.392578 0.891602 31.8856 0.891602 70.7342C0.891602 109.583 32.3846 141.076 71.2333 141.076Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M85.8002 52.1995C84.9836 49.1579 82.2502 48.7745 80.8003 50.1662C78.9419 51.9162 79.1086 56.1662 81.3336 57.4079C81.7002 57.5995 82.0919 57.7162 82.5003 57.7412C82.9086 57.7745 83.3169 57.7245 83.7086 57.5912C84.1002 57.4579 84.4586 57.2579 84.7586 56.9829C85.0669 56.7079 85.3169 56.3829 85.4919 56.0162C86.0502 54.8245 86.1586 53.4662 85.8002 52.1995V52.1995Z"
          fill="#F3123C"
        />
        <Path
          d="M165.459 98.0079C164.475 97.5246 162.859 98.7246 161.192 100.65C159.234 102.925 157.217 106.208 156.092 108.975C155.85 109.575 155.65 110.15 155.509 110.683C155.484 110.758 155.467 110.833 155.45 110.908C155.134 112.133 155.109 113.125 155.509 113.7C155.575 113.808 155.667 113.908 155.775 113.983C151.65 111.516 128.484 96.4329 124.459 93.8079L121.417 95.8413C121.417 95.8413 121.442 95.7579 121.459 95.7163V95.6996C121.459 95.6996 121.492 95.6163 121.5 95.5746C121.525 95.4829 121.55 95.3829 121.575 95.2829C121.6 95.1829 121.634 95.0746 121.659 94.9579C121.692 94.8496 121.717 94.7329 121.75 94.6163C122.567 91.2829 123.617 84.9913 124.259 81.4496C122.067 86.6829 119.617 91.8079 116.917 96.8079C116.642 97.3163 116.367 97.8329 116.075 98.3413C115.875 98.6913 115.684 99.0329 115.492 99.3746C115.384 99.5663 115.284 99.7579 115.175 99.9496C115.175 99.9496 115.167 99.9496 115.167 99.9663C114.875 100.491 114.575 101.008 114.275 101.525C109.9 108.658 104.759 114.4 98.8336 115.283C98.7086 115.3 98.5752 115.316 98.4419 115.333C96.3669 115.066 94.1086 114.708 92.2086 114.366C92.3502 114.358 92.4919 114.35 92.6336 114.35H92.6502C97.6752 114.058 99.2669 113.283 99.4002 112.733C99.4002 112.725 99.4002 112.716 99.4002 112.708C99.4586 112.4 99.0252 112.166 98.4836 112.166C95.2752 112.125 88.3752 111.958 87.8086 112.075C86.6836 112.441 85.6086 112.966 84.6169 113.608L84.6419 113.483C84.6836 113.325 84.7169 113.166 84.7419 113.016C84.8586 112.45 84.9502 111.941 85.0086 111.491C85.5086 107.825 84.2919 107.9 83.8336 109.2C83.4086 110.366 82.8919 111.491 82.2836 112.566C82.2669 112.566 82.2586 112.541 82.2419 112.533C79.8002 110.508 77.7169 108.1 76.0669 105.4C76.0919 105.375 76.1169 105.35 76.1336 105.325C78.8169 102.55 80.1836 98.1579 80.4669 94.3163C80.4836 94.0829 80.5002 93.8496 80.5086 93.6246C80.5919 91.7163 80.3919 89.9746 79.9419 88.6996C79.9586 88.6913 79.9669 88.6913 79.9836 88.6829C83.0086 87.3329 94.8169 82.3496 97.0419 81.5663C97.0919 81.5413 97.1336 81.5329 97.1752 81.5163C109.884 65.4663 112.867 61.5913 115.817 59.8413C118.925 58.0079 120.934 57.3496 159.159 46.6996H159.167C159.167 46.6996 159.175 46.6913 159.184 46.6913C159.292 46.6663 159.4 46.6329 159.517 46.5996C159.034 46.7746 158.725 47.4413 158.55 48.4329C158.534 48.5329 158.517 48.6413 158.509 48.7496C158.492 48.8329 158.475 48.9163 158.475 48.9996C158.375 49.8163 158.359 50.7996 158.4 51.8746C158.409 52.0663 158.417 52.2579 158.434 52.4496C158.45 52.6579 158.467 52.8663 158.484 53.0829C158.7 55.8163 159.275 58.9163 160.042 61.3579C160.075 61.4913 160.117 61.6246 160.167 61.7496C160.375 62.3913 160.592 62.9496 160.809 63.4246C161.35 64.6746 161.95 65.5163 162.575 65.6913C162.675 65.7246 162.767 65.7413 162.867 65.7329C156.484 67.4746 146.425 70.5579 132.759 74.6829C132.667 74.7163 132.584 74.7413 132.492 74.7663C138.009 78.1579 158.925 92.8663 165.234 97.8329C165.309 97.8913 165.384 97.9496 165.45 98.0079H165.459Z"
          fill="#F3123C"
        />
        <Path
          d="M161.908 49.7155C161.908 49.7155 161.9 49.7238 161.892 49.7322C161.633 49.9238 161.375 50.0988 161.1 50.2738C160.825 50.4405 160.533 50.5988 160.242 50.7488C160.1 50.8155 159.95 50.8905 159.8 50.9572C159.35 51.1488 158.883 51.3155 158.408 51.4405C158.392 50.8822 158.383 49.9238 158.475 48.9988C158.483 48.9155 158.492 48.8322 158.508 48.7488C158.508 48.6405 158.533 48.5322 158.55 48.4322C158.625 47.9238 158.742 47.4488 158.908 47.0905C158.967 46.9655 159.033 46.8655 159.092 46.7822C159.117 46.7488 159.142 46.7238 159.158 46.6988H159.167C159.258 46.5905 159.367 46.5072 159.492 46.4738C159.517 46.4655 159.55 46.4572 159.575 46.4488C159.633 46.4238 159.7 46.4238 159.767 46.4238C160.458 46.4655 161.308 47.6155 161.908 49.7155Z"
          fill="#404040"
        />
        <Path
          d="M163.125 65.5336C163.125 65.5336 163.042 65.5669 162.992 65.5753C162.95 65.5919 162.9 65.6003 162.858 65.6003C162.075 65.6586 161.017 64.4336 160.092 61.4753H160.083V61.4586C160.492 61.3836 160.892 61.3086 161.275 61.2419C162.233 61.0669 163.133 60.9169 164 60.8086V60.8253C164.358 63.5086 163.9 65.1753 163.125 65.5336V65.5336Z"
          fill="#404040"
        />
        <Path
          d="M165.1 102.574C165.033 102.549 164.967 102.524 164.908 102.499C164.742 102.441 164.575 102.374 164.417 102.299C164.183 102.207 163.967 102.107 163.742 102.007C163.458 101.882 163.175 101.749 162.892 101.607C162.617 101.474 162.342 101.324 162.067 101.166C161.775 100.999 161.475 100.832 161.192 100.649C161.167 100.641 161.15 100.624 161.125 100.607C161.125 100.607 161.125 100.599 161.108 100.599C162.05 99.5324 162.908 98.8074 163.617 98.3824C163.683 98.3408 163.742 98.3074 163.8 98.2741C163.858 98.2408 163.917 98.2074 163.975 98.1741C164.092 98.1074 164.208 98.0491 164.308 98.0158C164.358 97.9991 164.408 97.9741 164.458 97.9574C164.558 97.9241 164.658 97.8908 164.742 97.8741C164.792 97.8574 164.833 97.8491 164.875 97.8491C164.917 97.8408 164.958 97.8324 165 97.8324C165.083 97.8241 165.167 97.8241 165.242 97.8324C165.242 97.8324 165.275 97.8408 165.292 97.8408C165.35 97.8574 165.408 97.8741 165.458 97.8991C166.108 98.1991 166.467 100.174 165.1 102.574V102.574Z"
          fill="#404040"
        />
        <Path
          d="M159.817 111.257V111.265C159.742 111.382 159.667 111.499 159.592 111.607C159.2 112.165 158.8 112.624 158.409 112.982C157.467 113.84 156.6 114.132 156.042 113.974C155.992 113.957 155.942 113.94 155.9 113.924C155.859 113.907 155.825 113.882 155.784 113.857C155.742 113.832 155.709 113.799 155.675 113.757C155.642 113.715 155.609 113.682 155.575 113.632C155.517 113.549 155.467 113.449 155.417 113.324C155.309 113.015 155.259 112.59 155.284 112.049C155.3 111.849 155.325 111.632 155.367 111.399C155.375 111.299 155.4 111.199 155.417 111.099C155.434 111.04 155.45 110.974 155.459 110.907C155.475 110.832 155.492 110.757 155.517 110.682C155.592 110.374 155.684 110.049 155.8 109.699C155.85 109.557 155.9 109.407 155.959 109.257C155.992 109.157 156.025 109.057 156.067 108.957C156.067 108.957 156.084 108.957 156.092 108.974C156.475 109.157 156.825 109.34 157.15 109.515C157.35 109.624 157.542 109.732 157.734 109.849C157.859 109.915 157.975 109.99 158.084 110.057C158.35 110.224 158.609 110.39 158.867 110.574C159.059 110.699 159.242 110.824 159.409 110.957C159.55 111.049 159.684 111.157 159.817 111.257V111.257Z"
          fill="#404040"
        />
        <Path
          d="M115.167 99.9658C116.5 99.0491 118.834 97.4741 121.459 95.7074C122.425 92.5908 123.909 83.9491 124.534 80.7324C121.742 87.2991 118.617 93.7158 115.167 99.9574V99.9658Z"
          fill="#404040"
        />
        <Path
          d="M91.0417 51.082C91.0584 51.9154 91.1334 53.282 91.25 54.957C89.425 55.6987 87.4584 56.0237 85.4917 55.907C86.0417 54.707 86.15 53.357 85.7917 52.0904C86.7667 52.0904 89.9167 51.807 91.0417 51.082V51.082Z"
          fill="#404040"
        />
        <Path
          d="M92.4834 71.1328C92.5751 72.5745 92.6751 73.7161 92.7084 74.4161C93.8417 74.3078 96.1417 73.9245 95.8834 72.8245C95.7167 72.0995 94.4251 71.3661 92.4834 71.1328Z"
          fill="#404040"
        />
        <Path
          d="M81.3087 73.2911C79.9587 72.7995 79.3753 72.2078 79.292 71.6911C79.1587 70.8328 80.1837 70.3578 81.3087 70.1328V73.2911Z"
          fill="#404040"
        />
        <Path
          d="M66.2086 130.592C66.2086 133.358 65.3669 135.042 64.3336 135.367C62.7502 135.858 61.8086 133.075 61.4419 131.425C62.3502 131.292 64.1002 130.992 66.2086 130.592Z"
          fill="#404040"
        />
        <Path
          d="M63.4833 116.809C62.2417 116.592 61.5583 118.225 61.25 119.442C62.3333 119.384 63.6667 119.292 65.125 119.175C65.125 118.659 64.975 118.159 64.675 117.734C64.3833 117.309 63.9667 116.992 63.475 116.809H63.4833Z"
          fill="#404040"
        />
        <Path
          d="M68.8836 107.032C65.1586 107.848 61.6419 108.498 59.3086 108.932C59.9336 107.373 60.6003 105.832 61.2669 104.523C63.7169 105.607 66.2669 106.448 68.8836 107.032Z"
          fill="#404040"
        />
        <Path
          d="M45.0002 62.5165C41.6835 61.3498 38.0335 61.5498 34.8585 63.0665C31.6835 64.5915 29.2419 67.3082 28.0752 70.6248C27.4585 69.8582 26.6919 69.2332 25.8169 68.7832C24.9419 68.3332 23.9835 68.0748 23.0085 68.0248C22.0252 67.9748 21.0502 68.1248 20.1335 68.4748C19.2169 68.8248 18.3835 69.3665 17.6835 70.0582C16.9919 70.7498 16.4502 71.5832 16.0919 72.4998C15.7419 73.4165 15.5835 74.3915 15.6335 75.3748C15.6835 76.3582 15.9419 77.3165 16.3835 78.1915C16.8252 79.0665 17.4502 79.8415 18.2169 80.4582C19.6669 81.6082 21.5085 82.1415 23.3585 81.9665C25.2002 81.7832 26.9002 80.8998 28.1085 79.4915C29.2669 82.7165 31.6169 85.3665 34.6835 86.8915C37.7502 88.4165 41.2835 88.6998 44.5502 87.6832C43.6002 83.1832 41.8169 80.4415 41.1835 80.4832C38.1085 80.6915 37.6335 77.6165 40.5752 78.1998C42.0752 78.5248 40.6919 76.3748 39.5669 74.9915C41.5419 73.9498 43.3169 72.5665 44.8085 70.9082C51.3669 76.2248 53.3419 80.6165 48.7585 81.3998L46.2085 81.5165C47.8585 82.2498 49.6419 82.6415 51.4502 82.6748C53.0252 80.4498 53.8669 77.7832 53.8669 75.0582C53.8669 72.3082 53.0085 69.6248 51.4252 67.3832C49.8335 65.1415 47.5919 63.4415 45.0002 62.5332V62.5165Z"
          fill="#404040"
        />
        <Path
          d="M48.2168 81.4749C53.4585 85.0082 63.6668 82.3499 79.1501 78.7832"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M81.3085 70.1152C80.1835 70.3402 79.1502 70.8152 79.2919 71.6736C79.4585 72.6569 81.3419 73.8402 86.9502 74.3152C93.4085 74.8652 95.8335 74.0152 95.9002 73.0236C95.9502 72.2486 94.5919 71.3902 92.4585 71.1236"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M82.6421 49.2919C86.8754 49.1919 87.3754 57.6419 82.6587 57.6336C78.4421 57.6336 78.4837 49.3836 82.6421 49.2919Z"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M92.7084 74.4082C92.4834 70.6499 91.0584 53.8666 91.0584 50.6999C91.0584 47.5332 93.2917 43.4332 93.9084 42.4166C94.5834 41.3082 94.5834 40.0582 94.4584 37.0166C94.4084 35.6832 93.3417 35.6416 92.425 38.6916C91.6 41.4249 88.325 43.7082 88.4584 38.4416C88.5334 35.3832 89.025 31.1416 89.125 29.9832C89.325 27.6082 88.0584 27.3999 87.3417 29.9832C86.6334 32.3832 86.0584 34.8166 85.6167 37.2832"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M85.6671 36.8077C85.4171 33.8077 85.4171 30.0994 85.4004 28.9411C85.3671 26.5827 84.0421 26.5661 83.6171 29.1494C83.1754 31.8077 82.7087 35.9161 82.6504 37.5827"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M82.742 36.1333C82.2254 33.1999 82.0587 31.0999 81.9254 29.9749C81.6587 27.6416 80.3337 27.7666 80.1754 30.3916C80.017 33.1083 80.0004 35.8249 80.142 38.5416"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M80.1004 37.7403C79.3588 34.8736 79.1088 33.3903 78.9004 32.2653C78.4838 30.007 77.3338 30.2486 77.3421 32.8153C77.3088 35.4403 77.5004 38.0653 77.8921 40.6653C78.3838 42.8486 80.6088 49.232 80.8004 50.0486"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M81.3088 57.3086C81.3088 61.5669 81.2754 70.9336 81.3088 73.2836"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M85.8003 52.0826C86.7503 52.0826 89.9253 51.7992 91.042 51.0742"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M85.4917 55.907C87.4584 56.0237 89.425 55.6987 91.25 54.957"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M79.3001 71.6738C79.2084 73.5155 79.1251 79.3655 79.1084 80.2822"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M44.5503 87.691C41.542 88.641 38.3003 88.4826 35.392 87.2576C32.4837 86.0326 30.1087 83.8159 28.692 81.0076C27.267 78.1993 26.892 74.966 27.6253 71.9076C28.3587 68.841 30.1587 66.1409 32.7003 64.2743C35.242 62.416 38.367 61.5159 41.5087 61.7409C44.6503 61.9659 47.617 63.2993 49.867 65.5076C52.117 67.716 53.517 70.6493 53.8087 73.7826C54.1003 76.9243 53.267 80.0576 51.4587 82.6409"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M65.1252 119.174C64.9752 117.732 64.0836 116.674 63.1252 116.799C61.8336 116.974 60.4669 119.424 60.8086 126.432C61.1336 133.099 62.6919 135.507 64.0586 135.399C65.2002 135.316 66.2086 133.591 66.2086 130.574"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M61.2671 119.441C65.9004 119.232 75.7671 118.149 76.9254 117.974C78.0838 117.799 85.7671 112.366 87.8338 111.949C88.3838 111.841 95.3004 112.032 98.5088 112.066C100.009 112.074 100.709 113.849 92.2171 114.266"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M89.9917 113.816C92.425 114.383 96.775 115.041 100.042 115.433C101.567 115.616 100.975 117.658 91.7167 116.783"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M89.9917 116.174C92.3667 117.107 95.7084 118.057 98.7917 119.007C100.217 119.44 99.325 121.19 91 119.44"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M89.7836 118.398C91.2836 119.69 92.6336 120.923 95.0836 122.748C96.2253 123.598 95.3586 124.757 88.2086 120.998C86.9003 120.307 85.8669 121.907 84.5419 123.523C82.7919 125.648 82.1836 127.423 77.5669 128.365C72.4753 129.415 63.8336 131.082 61.4336 131.423"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M79.542 116.574C81.3587 114.316 82.817 111.782 83.8587 109.066C84.417 107.574 85.9503 107.716 84.6337 113.474"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M51.8838 118.7C54.5588 118.283 60.5255 117.142 63.1505 116.783"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M64.0754 135.415C50.8338 135.415 46.3504 136.232 42.7921 131.423C38.8671 126.115 43.2838 107.215 44.8421 96.3484C46.2004 86.8484 42.0254 80.4318 41.1921 80.4901C38.0921 80.6818 37.6421 77.6151 40.5838 78.2068C42.0838 78.5068 40.7171 76.3651 39.5754 74.9984C41.5421 73.9401 43.3171 72.5484 44.8171 70.8984C52.4671 77.1318 53.8838 82.0651 45.8588 81.4818C47.9588 82.4401 50.2421 82.9484 52.5504 82.9818"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M28.0754 70.6331C27.1671 69.5081 25.9254 68.6998 24.5338 68.3081C23.1421 67.9164 21.6588 67.9664 20.3004 68.4498C18.9338 68.9331 17.7588 69.8248 16.9254 71.0081C16.0921 72.1914 15.6421 73.5998 15.6421 75.0498C15.6421 76.4998 16.0921 77.9081 16.9254 79.0914C17.7588 80.2748 18.9421 81.1664 20.3004 81.6498C21.6671 82.1331 23.1421 82.1831 24.5338 81.7914C25.9254 81.3998 27.1671 80.5831 28.0754 79.4664C27.0838 76.6081 27.0838 73.5081 28.0754 70.6498V70.6331Z"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M56.25 117.957C57.6167 112.957 59.4667 108.099 61.775 103.457"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M44.7168 97.1154C51.8835 94.2737 57.2168 89.1904 58.3918 82.957"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M60.2754 84.8572C65.5004 83.8905 67.9504 82.8988 79.9421 88.5655C83.8587 86.8155 94.9337 82.1822 97.1754 81.4238"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M88.1753 92.7325C108.675 67.0242 112.284 61.8159 115.817 59.7326C118.934 57.8909 120.967 57.2409 159.575 46.4492"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M163.975 60.8242C164.333 63.4909 163.883 65.1492 163.125 65.5326C163.083 65.5492 163.042 65.5659 162.992 65.5742C162.942 65.5909 162.892 65.6076 162.842 65.6076C162.25 65.6576 161.525 64.9909 160.808 63.4242C160.592 62.9492 160.375 62.3909 160.167 61.7492C160.134 61.6659 160.108 61.5659 160.083 61.4742"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M158.434 52.4491C158.417 52.2575 158.409 52.0575 158.4 51.8741C158.267 49.4408 158.5 47.8825 158.909 47.0908C158.967 46.9658 159.034 46.8658 159.092 46.7825C159.125 46.7491 159.159 46.7241 159.184 46.6908C159.3 46.5741 159.417 46.4991 159.55 46.4658C160.275 46.2741 161.242 47.4325 161.892 49.7325"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M95.9083 73.0234C95.6083 76.0234 94.7667 81.3651 94.5 82.4318"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M59.3086 108.933C63.1503 108.233 70.2336 106.917 76.0836 105.25C77.7503 107.967 79.8419 110.383 82.3003 112.417"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M79.9419 88.5488C81.3252 92.5155 80.3419 100.915 76.0669 105.249"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M98.4336 115.241C111.484 113.816 120.775 88.5658 126.459 76.4574C139.034 72.6991 154.734 67.8158 162.859 65.6074"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M176.25 31.416C175.892 38.9827 174.717 50.7577 171.959 60.5243C169.3 60.3993 166.634 60.4993 164 60.8243V60.8077C163.134 60.916 162.234 61.066 161.275 61.241C160.892 61.3077 160.492 61.3827 160.084 61.4577V61.4743C160.084 61.4743 160.05 61.3993 160.042 61.3577C159.617 60.0077 159.225 58.2993 158.884 56.2077C158.7 55.0577 158.567 54.016 158.484 53.0827C158.467 52.866 158.45 52.6577 158.434 52.4493C158.417 52.2577 158.409 52.066 158.4 51.8743C158.359 50.7993 158.375 49.816 158.475 48.9993C158.384 49.9243 158.392 50.8827 158.409 51.441C158.884 51.316 159.35 51.1493 159.8 50.9577C159.95 50.8993 160.1 50.8327 160.242 50.7493C160.542 50.6077 160.825 50.4493 161.1 50.2743C161.375 50.1077 161.642 49.9327 161.892 49.7327C167.334 45.641 168.05 36.9743 176.25 31.416V31.416Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M159.8 50.957C159.367 51.157 158.9 51.3237 158.409 51.4654"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M164 60.8242C164 60.8242 163.983 60.8242 163.975 60.8326C163.075 60.9409 162.175 61.0742 161.275 61.2409C160.883 61.3159 160.483 61.3909 160.092 61.4742"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M159.817 111.274C159.734 111.39 159.659 111.499 159.584 111.607C159.192 112.165 158.792 112.624 158.4 112.982C157.459 113.849 156.584 114.149 156.034 113.974C155.984 113.957 155.934 113.94 155.892 113.924C155.85 113.899 155.809 113.874 155.775 113.849C155.734 113.824 155.7 113.79 155.667 113.757C155.634 113.715 155.6 113.682 155.567 113.632C155.509 113.549 155.459 113.449 155.409 113.324C155.3 113.015 155.25 112.59 155.275 112.049C155.292 111.849 155.317 111.632 155.359 111.399C155.367 111.299 155.392 111.199 155.409 111.099C155.425 111.04 155.442 110.974 155.45 110.907C155.467 110.832 155.484 110.757 155.509 110.682C155.584 110.374 155.675 110.049 155.792 109.699C155.842 109.557 155.892 109.407 155.95 109.257C155.984 109.165 156.025 109.065 156.067 108.957C156.55 107.707 157.292 106.199 158.359 104.449C159.334 102.849 160.267 101.59 161.125 100.615C161.125 100.607 161.125 100.607 161.125 100.607C162.067 99.5404 162.917 98.8237 163.617 98.382C163.684 98.3404 163.742 98.307 163.8 98.2737L163.975 98.1737C164.092 98.1154 164.2 98.0654 164.309 98.0154C164.359 97.9987 164.409 97.9737 164.459 97.957C164.559 97.9237 164.659 97.8904 164.742 97.8737C164.792 97.857 164.834 97.8487 164.875 97.8487C164.917 97.8404 164.959 97.832 165 97.832C165.084 97.832 165.167 97.832 165.242 97.832C165.259 97.832 165.275 97.832 165.292 97.8404C165.35 97.8487 165.4 97.8654 165.442 97.882C165.459 97.8904 165.467 97.8904 165.484 97.8987C166.109 98.1987 166.492 100.174 165.117 102.574"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M190.883 107.925C184.667 110.783 170.967 114.792 164.117 115.225C162.283 113.908 161.517 112.658 159.817 111.275V111.258C159.683 111.158 159.55 111.05 159.408 110.958C159.242 110.825 159.058 110.7 158.867 110.575C158.625 110.4 158.367 110.233 158.083 110.058C157.975 109.992 157.858 109.917 157.733 109.85C157.55 109.742 157.35 109.633 157.15 109.517C156.825 109.342 156.475 109.158 156.092 108.975C157.217 106.208 159.233 102.925 161.192 100.658C161.483 100.842 161.775 101.008 162.067 101.167C162.342 101.325 162.617 101.475 162.892 101.608C163.175 101.75 163.458 101.883 163.742 102.008C163.967 102.117 164.192 102.217 164.417 102.3C164.575 102.367 164.742 102.433 164.908 102.5C164.967 102.525 165.033 102.55 165.1 102.575H165.117C173.575 105.775 183.7 104.533 190.883 107.925V107.925Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M161.108 100.607C161.108 100.607 161.117 100.616 161.125 100.616C161.15 100.632 161.167 100.649 161.192 100.657"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M162.892 101.607C163.175 101.749 163.458 101.882 163.742 102.007C163.967 102.107 164.183 102.207 164.417 102.299"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M159.817 111.274C159.692 111.165 159.559 111.065 159.417 110.957"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M165.467 97.8913C159.158 92.8746 136.908 77.0913 132.633 74.5996"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M155.775 113.859C151.65 111.392 128.492 96.3003 124.484 93.6836C120.725 96.1919 117 98.7419 115.159 99.9753"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M121.442 95.7085C122.434 92.5918 123.892 83.9251 124.542 80.7168"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M61.2671 104.508C63.7254 105.599 66.2838 106.441 68.9088 107.033"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M58.3249 135.442C57.3416 136.042 56.5582 136.925 56.0749 137.975C55.5999 139.025 55.4499 140.2 55.6416 141.333L60.5666 169.375C60.8332 170.867 61.6832 172.192 62.9249 173.067C64.1666 173.933 65.7082 174.275 67.1999 174.017L166.758 156.483C167.5 156.35 168.208 156.075 168.842 155.675C169.475 155.275 170.025 154.742 170.45 154.133C170.883 153.517 171.183 152.825 171.35 152.092C171.508 151.358 171.525 150.6 171.392 149.858L166.475 121.817C166.342 121.075 166.067 120.367 165.667 119.733C165.258 119.1 164.733 118.55 164.125 118.125C163.508 117.692 162.817 117.392 162.083 117.225C161.35 117.067 160.592 117.05 159.85 117.183L65.6832 133.792"
          fill="#F5F5F5"
        />
        <Path
          d="M58.3249 135.442C57.3416 136.042 56.5582 136.925 56.0749 137.975C55.5999 139.025 55.4499 140.2 55.6416 141.333L60.5666 169.375C60.8332 170.867 61.6832 172.192 62.9249 173.067C64.1666 173.933 65.7082 174.275 67.1999 174.017L166.758 156.483C167.5 156.35 168.208 156.075 168.842 155.675C169.475 155.275 170.025 154.742 170.45 154.133C170.883 153.517 171.183 152.825 171.35 152.092C171.508 151.358 171.525 150.6 171.392 149.858L166.475 121.817C166.342 121.075 166.067 120.367 165.667 119.733C165.258 119.1 164.733 118.55 164.125 118.125C163.508 117.692 162.817 117.392 162.083 117.225C161.35 117.067 160.592 117.05 159.85 117.183L65.6832 133.792"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M71.3166 155.209L67.7583 155.834L68.9 162.309L72.4583 161.684L71.3166 155.209Z"
          fill="#F3123C"
        />
        <Path
          d="M76.3581 154.324L72.7998 154.958L73.9415 161.433L77.4998 160.808L76.3581 154.333V154.324Z"
          fill="#F3123C"
        />
        <Path
          d="M81.2331 153.459L77.6748 154.084L78.8165 160.559L82.3748 159.934L81.2331 153.459Z"
          fill="#F3123C"
        />
        <Path
          d="M86.1916 152.584L82.6333 153.209L83.775 159.684L87.3333 159.059L86.1916 152.584Z"
          fill="#F3123C"
        />
        <Path
          d="M91.2331 151.7L87.6748 152.325L88.8165 158.8L92.3748 158.166L91.2331 151.691V151.7Z"
          fill="#F3123C"
        />
        <Path
          d="M96.1081 150.834L92.5498 151.459L93.6915 157.934L97.2498 157.309L96.1081 150.834Z"
          fill="#F3123C"
        />
        <Path
          d="M101.075 149.959L97.5166 150.584L98.6583 157.059L102.217 156.434L101.075 149.959Z"
          fill="#F3123C"
        />
        <Path
          d="M106.033 149.092L102.475 149.717L103.617 156.192L107.175 155.567L106.033 149.092V149.092Z"
          fill="#F3123C"
        />
        <Path
          d="M110.992 148.217L107.434 148.842L108.575 155.317L112.134 154.692L110.992 148.217Z"
          fill="#F3123C"
        />
        <Path
          d="M115.95 147.342L112.392 147.967L113.533 154.442L117.092 153.817L115.95 147.342Z"
          fill="#F3123C"
        />
        <Path
          d="M120.908 146.467L117.35 147.092L118.492 153.567L122.05 152.942L120.908 146.467Z"
          fill="#F3123C"
        />
        <Path
          d="M166.45 121.817C166.317 121.075 166.042 120.367 165.642 119.733C165.242 119.1 164.717 118.55 164.1 118.125C163.483 117.692 162.792 117.392 162.058 117.225C161.325 117.067 160.567 117.05 159.825 117.183L62.5417 134.342L58.2667 135.483C57.275 136.075 56.4833 136.958 56.0083 138.008C55.5333 139.058 55.3833 140.233 55.5917 141.375L56.6917 147.7L167.517 128.167L166.45 121.825V121.817ZM142.758 129.3C142.175 129.3 141.608 129.125 141.125 128.8C140.642 128.475 140.267 128.017 140.042 127.475C139.817 126.933 139.758 126.342 139.875 125.775C139.992 125.2 140.267 124.675 140.683 124.267C141.092 123.858 141.617 123.575 142.192 123.458C142.767 123.342 143.358 123.4 143.892 123.625C144.425 123.85 144.892 124.225 145.217 124.708C145.542 125.192 145.717 125.758 145.717 126.342C145.717 127.125 145.408 127.875 144.85 128.425C144.3 128.975 143.55 129.292 142.767 129.292L142.758 129.3ZM151.65 127.725C151.067 127.725 150.5 127.55 150.017 127.225C149.533 126.9 149.15 126.442 148.933 125.9C148.708 125.358 148.65 124.767 148.767 124.2C148.883 123.633 149.158 123.1 149.575 122.692C149.983 122.283 150.508 122 151.083 121.883C151.658 121.767 152.25 121.825 152.783 122.05C153.325 122.275 153.783 122.65 154.108 123.133C154.433 123.617 154.608 124.183 154.608 124.767C154.608 125.55 154.3 126.3 153.75 126.85C153.2 127.4 152.45 127.717 151.667 127.717L151.65 127.725ZM160.542 126.167C159.958 126.167 159.392 125.992 158.908 125.667C158.425 125.342 158.05 124.883 157.825 124.342C157.6 123.8 157.542 123.208 157.658 122.642C157.767 122.075 158.05 121.542 158.467 121.133C158.875 120.725 159.4 120.442 159.975 120.325C160.55 120.208 161.142 120.267 161.675 120.492C162.217 120.717 162.675 121.092 163 121.575C163.325 122.058 163.5 122.625 163.5 123.208C163.5 123.992 163.192 124.742 162.642 125.292C162.092 125.842 161.342 126.158 160.558 126.158L160.542 126.167Z"
          fill="#404040"
        />
        <Path
          d="M56.7417 147.675L167.567 128.125"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M71.3166 155.209L67.7583 155.834L68.9 162.309L72.4583 161.684L71.3166 155.209Z"
          stroke="#2E2E2E"
          stroke-width="0.9"
        />
        <Path
          d="M76.3581 154.324L72.7998 154.958L73.9415 161.433L77.4998 160.808L76.3581 154.333V154.324Z"
          stroke="#2E2E2E"
          stroke-width="0.9"
        />
        <Path
          d="M81.2331 153.459L77.6748 154.084L78.8165 160.559L82.3748 159.934L81.2331 153.459Z"
          stroke="#2E2E2E"
          stroke-width="0.9"
        />
        <Path
          d="M86.1916 152.584L82.6333 153.209L83.775 159.684L87.3333 159.059L86.1916 152.584Z"
          stroke="#2E2E2E"
          stroke-width="0.9"
        />
        <Path
          d="M91.2331 151.7L87.6748 152.325L88.8165 158.8L92.3748 158.166L91.2331 151.691V151.7Z"
          stroke="#2E2E2E"
          stroke-width="0.9"
        />
        <Path
          d="M96.1081 150.834L92.5498 151.459L93.6915 157.934L97.2498 157.309L96.1081 150.834Z"
          stroke="#2E2E2E"
          stroke-width="0.9"
        />
        <Path
          d="M101.075 149.959L97.5166 150.584L98.6583 157.059L102.217 156.434L101.075 149.959Z"
          stroke="#2E2E2E"
          stroke-width="0.9"
        />
        <Path
          d="M106.033 149.092L102.475 149.717L103.617 156.192L107.175 155.567L106.033 149.092V149.092Z"
          stroke="#2E2E2E"
          stroke-width="0.9"
        />
        <Path
          d="M110.992 148.217L107.434 148.842L108.575 155.317L112.134 154.692L110.992 148.217Z"
          stroke="#2E2E2E"
          stroke-width="0.9"
        />
        <Path
          d="M115.95 147.342L112.392 147.967L113.533 154.442L117.092 153.817L115.95 147.342Z"
          stroke="#2E2E2E"
          stroke-width="0.9"
        />
        <Path
          d="M120.908 146.467L117.35 147.092L118.492 153.567L122.05 152.942L120.908 146.467Z"
          stroke="#2E2E2E"
          stroke-width="0.9"
        />
        <Path
          d="M161.675 137.109L65.3335 154.093L67.2168 164.793L163.559 147.809L161.675 137.109V137.109Z"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M135.1 40.3829C131.15 32.0913 125.625 24.6496 118.834 18.4746C116.617 20.8496 115.309 23.9163 115.125 27.1579C114.942 30.3996 115.9 33.5996 117.834 36.1996C119.767 38.8079 122.55 40.6496 125.709 41.4163C128.859 42.1829 132.184 41.8163 135.092 40.3829H135.1Z"
          fill="#404040"
        />
        <Path
          d="M128.983 41.8075C136.642 41.8075 142.85 35.5992 142.85 27.9409C142.85 20.2826 136.642 14.0742 128.983 14.0742C121.325 14.0742 115.117 20.2826 115.117 27.9409C115.117 35.5992 121.325 41.8075 128.983 41.8075Z"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M42.5918 39.9991L54.0335 37.9824"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M57.2586 56.2656L45.8169 58.2823"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M47.5083 57.9743C47.175 56.2577 47.225 54.491 47.6417 52.791C48.0583 51.091 48.8333 49.5077 49.925 48.1327C51.0083 46.766 51.7917 45.1743 52.2083 43.4743C52.625 41.7743 52.6667 40.0077 52.3417 38.291"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M55.5669 56.5492C55.3002 54.8242 54.6585 53.1742 53.6919 51.7159C52.7252 50.2576 51.4502 49.0326 49.9669 48.1159C48.4752 47.2076 47.1919 45.9826 46.2252 44.5242C45.2502 43.0742 44.6002 41.4242 44.3252 39.6992"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M165.617 81.3995L170.692 80.5078"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M179.675 78.9327L184.75 78.041"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M173.5 70.1582L174.392 75.2332"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M175.967 84.2168L176.858 89.2918"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M167.233 74.1406L171.45 77.1073"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M178.934 82.332L183.15 85.2987"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M180.759 71.7656L177.817 75.9656"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M172.567 83.457L169.625 87.6737"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M32.042 157.04L42.3753 142.299"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M29.8418 144.5L44.6085 154.833"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M146.442 172.374L143.725 170.832L145.267 168.115"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M143.725 170.832C144.4 170.49 145.15 170.307 145.908 170.299C146.858 170.299 147.792 170.582 148.583 171.107C149.375 171.632 149.992 172.382 150.35 173.265C150.717 174.149 150.808 175.107 150.625 176.04C150.442 176.974 149.983 177.832 149.308 178.499C148.633 179.174 147.783 179.632 146.85 179.815C145.917 179.999 144.95 179.907 144.075 179.54C143.2 179.174 142.442 178.557 141.917 177.774C141.392 176.982 141.108 176.057 141.108 175.107"
          stroke="#2E2E2E"
          stroke-width="0.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_8964_174175">
          <Rect width="190.758" height="180.292" fill="white" transform="translate(0.5)" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export const LoginAccountReview = memo(LoginAccountReviewIllustration)
